/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

module.exports = {
    mountPathBase:   '/ram/mnt',
    mountPathSMB:    '/ram/mnt/smb',
    mountPathNFS:    '/ram/mnt/nfs',
    defaultListSize: 7
};
